export default "__VITE_ASSET__DLvY05ti__"